import { apiGet } from "@/services/http";
import { endpoints } from "./endpoints";

export type PhoneQuickDialDto = {
  id: number;
  organization?: number | null;
  icon?: number | null;
  name: string;
  number: string;
  created_at?: string;
  updated_at?: string;
};

export type PhoneCoverImageDto = {
  id: number;
  organization?: number | null;
  image: string;
  uploaded_at?: string;
};

export type PhoneIconTypeDto = {
  id: number;
  name: string;
};

type Paginated<T> = {
  count?: number;
  next?: string | null;
  previous?: string | null;
  results?: T[];
};

function unwrapList<T>(payload: Paginated<T> | T[] | null | undefined): T[] {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload.results)) return payload.results;
  return [];
}

export async function fetchPhoneQuickDials() {
  const response = await apiGet<Paginated<PhoneQuickDialDto> | PhoneQuickDialDto[]>(
    `${endpoints.phoneQuickDial}?size=100`,
  );
  return unwrapList(response);
}

export async function fetchPhoneCoverImages() {
  const response = await apiGet<Paginated<PhoneCoverImageDto> | PhoneCoverImageDto[]>(
    `${endpoints.phoneCoverImage}?size=20`,
  );
  return unwrapList(response);
}

export async function fetchPhoneIconTypes() {
  const response = await apiGet<Paginated<PhoneIconTypeDto> | PhoneIconTypeDto[]>(
    `${endpoints.phoneIconTypes}?size=100`,
  );
  return unwrapList(response);
}
